import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import InstallmentsModal from "components/InstallmentsModal";
import { trackResumoCompraEvent } from "utils/gtm";
import { BrlFormatCurrency } from "../../../lib";

const Label = styled.div`
  font-size: 16px;
  margin: 16px 0 8px;
  color: ${(p) => (p.$enabled ? "var(--text-dark, #1D1D1F)" : "#707070")}
`;

const Trigger = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 14px 16px;
  background: #f5f5f7;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  color: ${(p) => (p.$placeholder ? "#707070" : "var(--text-dark, #1D1D1F)")};
  cursor: pointer;
  text-align: left;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TriggerLabel = styled.span`
  color: ${(p) => (p.$enabled ? "var(--text-dark, #1D1D1F)" : "inherit")};
  font-weight: ${(p) => (p.$enabled ? "500" : "inherit")};
`;

export default function InstallmentsTrigger({
  installments,
  selected,
  onSelect,
  disabled,
}) {
  const [open, setOpen] = useState(false);

  const selectedObj =
    installments?.find(
      (i) => Number(i.installmentNumber) === Number(selected),
    ) || null;

  const label = selectedObj
    ? Number(selectedObj.installmentNumber) === 1
      ? "Pagamento à vista"
      : `${selectedObj.installmentNumber}x de ${BrlFormatCurrency(
          selectedObj.installmentPrice,
        )}`
    : "Em quantas parcelas deseja pagar?";

  return (
    <>
      <Label $enabled={!disabled}>Parcelamentos disponíveis:</Label>
      <Trigger
        type="button"
        $placeholder={!selectedObj}
        disabled={disabled || !installments?.length}
        onClick={() => {
          trackResumoCompraEvent({ title: "abrir-parcelamento" });
          setOpen(true);
        }}
      >
        <TriggerLabel $enabled={!disabled}>{label}</TriggerLabel>
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M6 9L12 15L18 9" stroke="#171717" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </span>
      </Trigger>
      <InstallmentsModal
        open={open}
        onClose={() => setOpen(false)}
        installments={installments || []}
        selected={selected}
        onSelect={(n) => {
          trackResumoCompraEvent({ title: "selecionar-parcela", parcela: n });
          onSelect(n);
          setOpen(false);
        }}
      />
    </>
  );
}

InstallmentsTrigger.propTypes = {
  installments: PropTypes.array.isRequired,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
